import { api } from '@/utils/api';
import { getFeaturesEndpoint } from '@/utils/constants/apiEndpoints';

export function fetchFeaturesData() {
  return api.get(getFeaturesEndpoint());
}
